/**
 * IMPORTANT!
 * These functions are here as a work around for the missing node polyfills 
 * These functions are required for the packages:
 *  createHash: @aws-sdk => for Bundling, build error, Runtime, Uncaught ReferenceError
 *  createHmac: @aws-sdk => for Bundling, build error, Runtime, Uncaught ReferenceError
 *  randomBytes: @amzn/katal-logger => Runtime, Uncaught ReferenceError
 *
 *  All of these functions are required since all of them result in "Uncaught ReferenceError: Cannot access X before initialization"
 *  which happens because vite can not bundle correctly all the crypto polyfills required for the mentioned packages
 *
 *  "crypto-browserify": "^3.12.1" lib  with allias configuration did not work
 *  "node-polyfills" plug in including crypto did not work
 *
 */


export function createHash(algorithm) {
  console.log("createHash called with algorithm:", algorithm);
  return {
    update(data) {
      console.log("hash update called with:", data);
      return this;
    },
    digest(encoding) {
      console.log("hash digest called with encoding:", encoding);
      return new Uint8Array(32);
    }
  };
}

export function createHmac(algorithm, key) {
  console.log("createHmac called with algorithm:", algorithm, "and key:", key);
  return {
    update(data) {
      console.log("hmac update called with:", data);
      return this;
    },
    digest(encoding) {
      console.log("hmac digest called with encoding:", encoding);
      // Return a dummy hmac for testing
      return new Uint8Array(32);
    }
  };
}

export function randomBytes(size) {
  console.log("randomBytes called with size:", size);
  
  // Use a combination of current timestamp and Math.random()
  const bytes = new Uint8Array(size);
  for (let i = 0; i < size; i++) {
    bytes[i] = Math.floor(Math.random() * 256);
  }
  
  // Add some entropy using the current timestamp
  const timestamp = new Date().getTime();
  for (let i = 0; i < 8; i++) {
    bytes[i % size] ^= (timestamp >> (i * 8)) & 0xFF;
  }

  return bytes;
}

